import React from 'react';
import { NavLink } from 'react-router-dom';

const linkClass = ({ isActive }) =>
  `px-4 py-2 rounded-md text-sm font-medium transition-colors ${
    isActive ? 'bg-purple-600 text-white' : 'text-gray-400 hover:text-white hover:bg-gray-800'
  }`;

// Tab strip shared by every /admin/* page.
const AdminNav = () => (
  <div className="flex items-center gap-2 mb-8 border-b border-gray-800 pb-4">
    <NavLink to="/admin" end className={linkClass}>Overview</NavLink>
    <NavLink to="/admin/analyses" className={linkClass}>Analyses</NavLink>
  </div>
);

export default AdminNav;
